// ========== 二维码弹窗功能 ==========
function showQRCode(type) {
  const modal = document.getElementById('qrcodeModal');
  const title = document.getElementById('qrcodeTitle');
  const image = document.getElementById('qrcodeImage');
  const text = document.getElementById('qrcodeText');

  const qrConfig = {
    wechat: {
      image: 'https://cdn.shopify.com/s/files/1/0791/1446/9592/files/67cd77bbf067e3ca2caf9c7d10318bd4.jpg?v=1778048918',
      text: window.qrTexts?.wechat || ''
    },
    qq: {
      image: 'https://cdn.shopify.com/s/files/1/0791/1446/9592/files/QQ.png?v=1778053771',
      text: window.qrTexts?.qq || ''
    },
    Telegram: {
      image: 'https://cdn.shopify.com/s/files/1/0791/1446/9592/files/Telegram.png?v=1778053824',
      text: window.qrTexts?.Telegram || ''
    }
  };

  const config = qrConfig[type];
  if (config) {
    if (title) title.textContent = config.title || '';
    image.src = config.image;
    text.textContent = config.text;
    modal.classList.add('active');
  }
}

function closeQRCode() {
  const modal = document.getElementById('qrcodeModal');
  modal.classList.remove('active');
}

document.addEventListener('DOMContentLoaded', function () {
  const qrcodeModal = document.getElementById('qrcodeModal');
  if (qrcodeModal) {
    qrcodeModal.addEventListener('click', function (e) {
      if (e.target === qrcodeModal) closeQRCode();
    });
  }
});
